import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { DataTable } from '../../components/Tables';
import PageHeader from '../shared/PageHeader';
import { countriesApi, extractList } from '../../api/facades';

const CountriesListPage: React.FC = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');

  const { data: res, isLoading } = useQuery({
    queryKey: ['countries', search],
    queryFn: () => countriesApi.list({ search: search || undefined, perPage: 50 }),
  });
  const rows = extractList(res);

  const columns = [
    { key: 'name', label: 'Name' },
    { key: 'sortname', label: 'Code' },
    {
      key: 'states',
      label: 'States',
      render: (r: any) => (Array.isArray(r.states) ? r.states.length : r.states_count ?? '—'),
    },
  ];

  return (
    <div>
      <PageHeader title="Countries" subtitle="Reference data. Read-only." />
      <div className="bg-white dark:bg-slate-800/50 rounded-2xl p-6">
        <div className="mb-4">
          <input
          type="search"
          placeholder="Search by name or code"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="w-full max-w-xs rounded-lg border border-gray-300 bg-white dark:bg-slate-800 dark:border-gray-600 py-2 px-3 text-sm text-slate-700 dark:text-slate-200 focus:border-primary-300 focus:outline-none"
        />
      </div>
      <DataTable
        columns={columns}
        data={rows}
        loading={isLoading}
        emptyMessage="No countries found."
        onRowClick={(id) => navigate(`/dashboard/settings/countries/${id}`)}
        />
      </div>
    </div>
  );
};

export default CountriesListPage;
